import React from 'react'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import { convertTemplateTextPropertiesToStyle } from '../utils/textPropertiesUtils'

function ColumnHandler({ columnData }) {
  if (!columnData) {
    return null
  }

  if (columnData.type === 'image') {
    if (!columnData.imageId) {
      return null
    }

    const imageStyle = {
      width: '100%',
      height: 'auto',
      display: 'block',
    }

    if (columnData.imagePadding) {
      imageStyle.padding = columnData.imagePadding
    }

    if (columnData.imagePaddingTop) {
      imageStyle.paddingTop = columnData.imagePaddingTop
    }

    return (
      <div>
        <img src={getImageLink(columnData.imageId)} alt="Header" style={imageStyle} crossOrigin="anonymous" />
      </div>
    )
  }

  if (columnData.type === 'text' && columnData.text && columnData.text.length > 0) {
    return (
      <div>
        {columnData.text.map((textItem, index) => {
          const textStyle = convertTemplateTextPropertiesToStyle(textItem)
          return (
            <div key={index} style={textStyle}>
              {textItem.text}
            </div>
          )
        })}
      </div>
    )
  }

  return null
}

export default function MultipleTemplateHeadersPrintableComponent({
  prescriptionData,
  leaveSpace,
  debug = false,
  topPadding = '2px',
}) {
  const columnData = prescriptionData?.header?.headerColumns || []
  if (columnData?.length === 0) {
    return <></>
  }
  return (
    <div
      style={{ display: 'grid', gridTemplateColumns: `${columnData.map(() => '1fr').join(' ')}` }}
      className="px-1"
    >
      {columnData.map((column, index) => (
        <ColumnHandler key={index} columnData={column} />
      ))}
    </div>
  )
}
